import { bind } from 'bind-decorator';
import React from 'react';

type TIndex = string | number;

interface ISelectedMenu {
  description?: string;
  alt?: string;

  [index: number]: string | ISelectedMenu;
  [key: string]: string | ISelectedMenu;
}

interface IProps {
  selectedKey: TIndex;
  menu: Record<TIndex, string | object>;
  selected: ISelectedMenu;
  tabIndex?: number;

  onClick: (key: TIndex, text: string, e: React.MouseEvent) => void;
}

interface IValue {
  text: string;
  alt: string;
}

class QuickPickRawItem extends React.Component<IProps> {
  render() {
    const { alt, text } = this.value;

    return (
      <div className="menu-item" tabIndex={this.props.tabIndex} onClick={this.onClick}>
        <span className="text">{text}</span>
        <span className="text">{alt}</span>
        <span className={this.chevron} />
      </div>
    );
  }

  get selectedPage(): string | ISelectedMenu {
    const { selected, selectedKey } = this.props;
    const { [selectedKey]: selectedPage } = selected;

    return selectedPage;
  }

  get value(): IValue {
    const { selectedPage } = this;

    if (typeof selectedPage === 'string') {
      return {
        text: selectedPage,
        alt: ''
      };
    }

    return {
      text: selectedPage.description || '',
      alt: selectedPage.alt || ''
    };
  }

  get page(): string | object {
    const { menu, selectedKey } = this.props;
    const { [selectedKey]: page } = menu;

    return page;
  }

  get chevron(): string {
    const { page } = this;

    const isMenu = typeof page === 'object' && Object.keys(page).length !== 0;

    return isMenu ? 'fa fa-chevron-right' : '';
  }

  @bind
  private onClick(e: React.MouseEvent) {
    const { selectedKey } = this.props;
    const { text } = this.value;

    this.props.onClick(selectedKey, text, e);
  }
}

export default QuickPickRawItem;
